import { featureEnabled } from './features';
import { TaxIdValidationData } from './validation/tax-id';

export let generateValidCodiceFiscale = async (_data: TaxIdValidationData) =>
    '?';

window.setTimeout(() => {
    if (featureEnabled('IS_DEV')) {
        generateValidCodiceFiscale = async (data: TaxIdValidationData) => {
            const CodiceFiscale = await import('codice-fiscale-js').then(
                (module) => module.default
            );

            const codiceData = {
                name: data.firstname,
                surname: data.lastname,
                gender: data.gender === 'MALE' ? 'M' : 'F',
                day: data?.dateOfBirth?.getDate(),
                month: data?.dateOfBirth?.getMonth() + 1,
                year: data?.dateOfBirth?.getFullYear(),
                birthplace: data?.placeOfBirth
            };

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            // @ts-ignore
            const codice = new CodiceFiscale(codiceData);
            // @ts-ignore
            return codice?.code;
        };
    }
}, 1000);
